// const API_ROOT = 'https://app-node-talkfintech.ondotmail.com:3015';
const API_ROOT = 'https://app-node.talkfintech.com:3016';

// const webPath = 'https://talkfintech.com'

const webPath = 'https://talkfintech-pro.b-cdn.net'

export { API_ROOT , webPath};